<template>
  <div class="widget-card">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.widget-card {
  border-radius: rem-calc(12);
  border: 1px solid #E3E8EF;
  background-color: #fff;
  box-shadow: 0px 1px 2px 0px #1018280F;
  box-shadow: 0px 1px 3px 0px #1018281A;
  padding: rem-calc(19) rem-calc(22);
  flex-grow: 1;
}
@include breakpoint(small) {
  .widget-card {
    padding: rem-calc(8) rem-calc(12) rem-calc(12);
  }
}
</style>
